const OVERLAY_OPEN_SELECTORS = [
  ".qlfr-modal-container.active", // instruction / confirm / enqueue / AI analysis / clone
  ".cfm-backdrop.open",           // bulk "add to sequence" confirm
  "#candidate-drawer.open",       // the candidate profile card
];

// A popup opened from inside the card — compose an email, call, message history
// (Bootstrap) or the full AI analysis (a qlfr modal) — stacks on top of it, so
// the card has to stop scrolling underneath. Both flavours count.
const INNER_POPUP_SELECTORS = [".modal.show", ".qlfr-modal-container.active"];

const CARD_ID = "candidate-drawer";

// body{overflow:hidden} alone collapses the document height and jumps to the top,
// so the offset is parked in style.top and handed back on unlock.
let lockedScrollY: number | null = null;

export function lockPageScroll(): void {
  if (lockedScrollY !== null) return; // already locked; keep the first offset

  lockedScrollY = window.scrollY;
  document.body.style.top = `-${lockedScrollY}px`;
  document.body.classList.add("qlfr-scroll-locked");
}

export function unlockPageScroll(): void {
  if (lockedScrollY === null) return; // never locked — do not scroll to 0

  const restoreTo = lockedScrollY;
  lockedScrollY = null;
  document.body.classList.remove("qlfr-scroll-locked");
  document.body.style.top = "";
  window.scrollTo(0, restoreTo);
}

// Whether a popup is currently stacked over the candidate card.
export function innerPopupOpen(): boolean {
  return INNER_POPUP_SELECTORS.some((sel) => document.querySelector(sel) !== null);
}

// Stacked overlays stay locked until the last one closes, so only the topmost
// one — the one under the cursor — can scroll.
export function syncPageScrollLock(): void {
  const open = OVERLAY_OPEN_SELECTORS.some((sel) => document.querySelector(sel) !== null);

  if (open) lockPageScroll();
  else unlockPageScroll();

  document.getElementById(CARD_ID)?.classList.toggle("drawer-scroll-locked", innerPopupOpen());
}

let syncScheduled = false;

// one recompute per frame; the app mutates the DOM constantly
function scheduleScrollLockSync(): void {
  if (syncScheduled) return;

  syncScheduled = true;
  window.requestAnimationFrame(() => {
    syncScheduled = false;
    syncPageScrollLock();
  });
}

let modalObserver: MutationObserver | null = null;

function observeModalState(): void {
  modalObserver?.disconnect();
  modalObserver = new MutationObserver(scheduleScrollLockSync);
  modalObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
    childList: true,
    subtree: true,
  });

  syncPageScrollLock(); // a modal may already be open on this render
}

export function initQlfrModal(): void {
  $(".qlfr-show-modal").click(function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    $(".qlfr-modal-container").addClass('active')
  });

  $(".submit-form-button").on("click", function(e) {
    $("#bot-setting-form").submit();
  })

  $(".qlfr-show-ai-sequence-modal").click(function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    $(".qlfr-modal-container.ai-sequence-generator").addClass('active')
  });

  $(".qlfr-show-the-modal").on('click', function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    console.log( $(this).data('modal'))
    $("#"+ $(this).data('modal')).addClass('active')
  });

  $(".qlfr-show-closest-modal").on('click', function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    $(this).parent().find('.qlfr-modal-container').addClass('active')
    sendTitleListener(event.currentTarget);
  });

  $(".qlfr-modal-container").click(function(event) {
    if ($(event.target).is(".qlfr-modal-container")) {
      closeBotModal();
    }
  });

  $(".qlfr-modal-close").click(function(event) {
    closeBotModal();
  });

  $(document).on('ajax:success', '.upload-to-jobylon-form', event => {
    closeBotModal();
    $(event.target).parents(".prospect").find(".push-to-jobylon").replaceWith("<i class='fal fa-external-link'></i> Uploaded to Jobylon")
  });

  $(document).on('ajax:error', '.upload-to-jobylon-form', event => {
    alert("There was an error pushing to Jobylon")
    closeBotModal();
  });

  // a Turbo visit mid-modal would cache a body stuck at position:fixed
  document.removeEventListener("turbo:before-cache", unlockPageScroll);
  document.addEventListener("turbo:before-cache", unlockPageScroll);

  observeModalState();
}

function closeBotModal(): void {
  $(".qlfr-modal-container").removeClass('active')
  syncPageScrollLock();
}

const sendTitleListener = (currentTarget) => {
  $(".send-title").on('click',(e) => {
    e.preventDefault();
    const form = $(e.currentTarget.closest('form'))
    const selected = form.find('.selectpickerr option:selected')
    const gender = selected.val()
    const display = selected.text()
    $.ajax({
      url: `/bots_prospect/${form.data('id')}/${gender}`,
      data: {
        authenticity_token: $('[name="csrf-token"]').attr('content'),
      },
      type: 'PATCH',
      success: function() {
        closeBotModal();
        $(currentTarget).text(`[${display}]`);
      },
    });
  })
}

export function initAiSequenceModal() {
  initTabs();
  initUploadFileInput();
}

function initTabs() {
  const $inputTab = $('.ai-sequence-generator .ai-tab.input')
  const $uploadTab = $('.ai-sequence-generator .ai-tab.upload')
  const $linkTab = $('.ai-sequence-generator .ai-tab.link')
  const $inputForm = $('.ai-sequence-generator .input-form')
  const $jobUploader = $('.ai-sequence-generator .upload-job-ad')
  const $jobLink = $('.ai-sequence-generator .link-job-ad')

  $inputTab.on('click', function(event) {
    $inputTab.addClass('active');
    $uploadTab.removeClass('active')
    $linkTab.removeClass('active')

    $inputForm.removeClass('d-none')
    $jobUploader.addClass('d-none')
    $jobLink.addClass('d-none')
  });

  $uploadTab.on('click', function(event) {
    $uploadTab.addClass('active');
    $inputTab.removeClass('active')
    $linkTab.removeClass('active')

    $inputForm.addClass('d-none')
    $jobUploader.removeClass('d-none')
    $jobLink.addClass('d-none')
  });

  $linkTab.on('click', function(event) {
    $linkTab.addClass('active');
    $inputTab.removeClass('active')
    $uploadTab.removeClass('active')

    $inputForm.addClass('d-none')
    $jobUploader.addClass('d-none')
    $jobLink.removeClass('d-none')
  });
}

function initUploadFileInput() {
  const $fileInput = $('input[type="file"]');

  if ($fileInput.length) {
    $fileInput.on('change', function (this: HTMLInputElement) {
      const maxSize = parseInt($(this).data('maxSize') as string, 10);
      const file = this.files?.[0];

      if (file && file.size > maxSize) {
        alert('File size must be less than 5MB.');
        $(this).val('');
      }
    });
  }
}
